import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth';
import { ToastProvider } from './lib/toast';
import Landing from './pages/Landing';
import VehicleDetail from './pages/VehicleDetail';
import BookingSuccess from './pages/BookingSuccess';
import ReviewPage from './pages/ReviewPage';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';

function ProtectedAdmin({ children }) {
  const { user, checking } = useAuth();
  if (checking) return <div style={{ padding: 80, textAlign: 'center', color: '#94A3B8' }}>Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/cars/:id" element={<VehicleDetail />} />
              <Route path="/booking/success" element={<BookingSuccess />} />
              <Route path="/review/:bid" element={<ReviewPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedAdmin>
                    <AdminPanel />
                  </ProtectedAdmin>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
